import { observer } from "mobx-react-lite";

import { Sidebar } from "@/components/sidebar";
import * as Skeleton from "@/components/skeleton/Skeleton";
import { useStore } from "@/store";

import { CreateDocButton } from "../documents/CreateDocButton";
import { SearchPopover } from "../top-menu/SearchPopover";

export const MiddleMenu = observer(function MiddleMenu() {
  const { documentTree, auth } = useStore();

  if (!auth.isLoggedIn) {
    return null;
  }

  if (!documentTree.root) {
    return (
      <Sidebar.Group className="p-1.25 min-h-[94px] flex-shrink-0">
        <Skeleton.Root>
          <Sidebar.GroupSection className="mt-0 p-0">
            <Skeleton.Block className="w-[30px] h-[84px]" />
          </Sidebar.GroupSection>
        </Skeleton.Root>
      </Sidebar.Group>
    );
  }

  return (
    <Sidebar.Group className="p-0 relative flex-col min-h-[94px] flex-shrink-0">
      <div className="flex flex-col justify-between gap-2 p-1.25">
        <CreateDocButton />
        <SearchPopover />
      </div>
    </Sidebar.Group>
  );
});
